import type { KeywordDefinition, SchemaValidateFunction } from 'ajv';
import { MultipleSelectionProperty } from 'shared';
import { MultipleSelectionValueForValidation } from '../../shared';

const KEYWORD = 'requiredSubtextMultipleSelection';

const validate: SchemaValidateFunction = (
  schema: MultipleSelectionProperty['requiredSubtextMultipleSelection'],
  data: MultipleSelectionValueForValidation
) => {
  if (!schema || !schema.length || !data?.length) {
    return true;
  }

  const errorMessages = schema
    .filter(({ value }) => {
      const matchValue = data.find((item) => item.value === value);
      if (!matchValue) {
        return false;
      }
      return !matchValue.subtext;
    })
    .map(({ message }) => message);

  if (!errorMessages.length) {
    return true;
  }

  validate.errors = errorMessages.map((message) => ({
    keyword: KEYWORD,
    params: { keyword: KEYWORD },
    message,
  }));
  return false;
};

export const requiredSubtextMultipleSelection: KeywordDefinition = {
  keyword: KEYWORD,
  type: 'array',
  validate,
};
